import { cn } from '@cocoonspace/ui/lib/utils'

import { OutlookIcon } from '~/components/icons/outlook-icon'
import { useListIntegrations } from '~/domains/account/hooks/use-list-integrations.hook'
import { ConnectBtn } from '../connect-btn'
import {
	ProviderDescription,
	ProviderName,
	ProviderWrapper,
} from './provider-wrapper'

export const OutlookCalendar = ({
	dense = false,
	showDeleteButtons,
}: {
	dense?: boolean
	showDeleteButtons?: boolean
}) => {
	const { data: userIntegrations } = useListIntegrations()

	const hasOutlookCalendar = !!userIntegrations?.outlook?.connected

	return (
		<ProviderWrapper
			isActive={hasOutlookCalendar}
			dense={dense}
		>
			<ProviderDescription>
				<OutlookIcon className={cn('size-6', { 'size-4': dense })} />
				<ProviderName dense={dense}>Outlook Calendar</ProviderName>
			</ProviderDescription>

			<ConnectBtn
				provider='outlook'
				connected={hasOutlookCalendar}
				showDeleteButtons={showDeleteButtons}
			/>
		</ProviderWrapper>
	)
}
